import { render, staticRenderFns } from "./MainActivity.vue?vue&type=template&id=18705ca4&"
import script from "./MainActivity.vue?vue&type=script&lang=js&"
export * from "./MainActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports